export const EVERYONE_GROUP_ID = 'b8e95938-c615-11e7-b5ab-6c4008b85488';

export const GROUP_TYPE_TEAM = 'TEAM';
export const GROUP_TYPE_ROLE_GROUP = 'ROLE_GROUP';
